import {
  composeValidations,
  pathAvailableValidation,
  pathValidation,
} from './common.js';

export function createDashboardMenuPluginValidation(projectFolder: string) {
  return composeValidations([
    [
      pathAvailableValidation(projectFolder),
      'The dashboard menu plugin folder must be unique. Select a name that has not been used yet in your app.',
    ],
    [
      pathValidation,
      'The dashboard menu plugin folder must be a valid path ([a-z0-9-/]+) and must not start with a dot.',
    ],
  ]);
}
